import { Link } from 'react-router-dom';
import './PortfolioMold.css';

export default function PortfolioMold() {
  return (
    <main id="top">

      <section className="cs-hero">
        <div className="cs-bg"><img className="ph" src="/images/construction-site.jpg" alt="Project photo — VA facility, Stanton Work Center" /></div>
        <div className="cs-scrim"></div>
        <div className="wrap-wide">
          <nav className="crumb"><Link to="/">Home</Link><span className="sep">/</span><Link to="/portfolio/">Portfolio</Link><span className="sep">/</span><b>Mold Remediation Contract</b></nav>
          <div className="cs-htext">
            <span className="eyebrow">Case study · Dept. of Veterans Affairs</span>
            <h1>Government Mold Remediation Contract</h1>
            <div className="cs-facts">
              <div className="cs-fact"><div className="k">Client</div><div className="v">Dept. of Veterans Affairs</div></div>
              <div className="cs-fact"><div className="k">Contract Value</div><div className="v">$70,080</div></div>
              <div className="cs-fact"><div className="k">Status</div><div className="v">Awarded · Ongoing</div></div>
              <div className="cs-fact"><div className="k">Scope</div><div className="v">Proposal & Compliance</div></div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec-pad">
        <div className="wrap-wide">
          <div className="cs-layout" style={{ marginTop: '0' }}>

            <div className="cs-main">
              <div className="cs-block">
                <span className="cs-kicker">Project overview</span>
                <h2>Subcontract proposal & compliance support, end to end.</h2>
                <p>This project involved supporting a client in securing a government contract for mold remediation and restoration at the Stanton Work Center in Stanton, Kentucky. Our role focused on subcontract proposal preparation and compliance support — including work-plan development, material verification, and documentation review.</p>
                <p>Every requirement was aligned with federal standards to ensure a complete and compliant submission. The remediation and restoration work itself was performed by the awarded contractor, while ATZ Solution positioned the bid and managed the federal paperwork.</p>
              </div>

              <div className="cs-block">
                <span className="cs-kicker">Key strategies</span>
                <h2 style={{ marginBottom: '22px' }}>How we positioned the win.</h2>
                <ul className="cs-strats">
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Prepared a compliant subcontract work plan for the government mold remediation contract.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Verified materials and methods against approved federal specifications.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Reviewed all proposal documents to reduce errors and compliance risk.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Supported client positioning to secure the federal award.</span></li>
                </ul>
              </div>
            </div>

            <aside>
              <div className="cs-info">
                <div className="hd">Project Information</div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-landmark" /></svg></span><div><div className="k">Client</div><div className="val">Department of Veterans Affairs (VA)</div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-dollar" /></svg></span><div><div className="k">Contract Value</div><div className="val">$70,080.00 <span className="mut">USD</span></div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-cal" /></svg></span><div><div className="k">Date</div><div className="val">January 4, 2024 – Ongoing</div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-user" /></svg></span><div><div className="k">Point of Contact</div><div className="val">Sunday Street, P.Eng, CSP<br /><span className="mut">sunday.street@usda.gov</span></div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-mappin" /></svg></span><div><div className="k">Location</div><div className="val">Stanton Work Center<br /><span className="mut">705 W College Ave, Stanton, KY 40380</span></div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-hash" /></svg></span><div><div className="k">Solicitation No.</div><div className="val"><a href="#">12443924Q0055</a></div></div></div>
              </div>
            </aside>

          </div>

          <div className="cs-cta">
            <div className="ct">
              <h3>Need our help to win government contracts?</h3>
              <p>Most people think federal contracting is simple — fill out a few forms and you're done. The reality is far more complex. Let our specialists handle it.</p>
            </div>
            <Link className="btn btn-light" to="/#contact">Contact Us <span className="arw">→</span></Link>
          </div>
        </div>
      </section>

      <section className="finalcta" id="contact">
        <div className="wrap">
          <span className="starrow center" style={{ marginBottom: '24px' }}><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg></span>
          <img className="brand-logo" style={{ height: '60px', margin: '0 auto' }} src="/atz-logo-white.png" alt="ATZ Solution" />
          <span className="eyebrow">Ready when you are</span>
          <h2>Let's win your next federal contract together.</h2>
          <p>Book a free consultation and a specialist will map the exact registrations, certifications, and proposal support your business needs to compete.</p>
          <div className="hero-actions">
            <a className="btn btn-light" href="/contact-us/">Book a Free Consultation <span className="arw">→</span></a>
            <Link className="btn btn-outline-light" to="/portfolio/">View More Projects</Link>
          </div>
          <div className="call">Prefer to talk now? Call <b>(704) 459-8642</b> · Mon–Fri 9:00–6:00 ET</div>
        </div>
      </section>

    </main>
  );
}
